// TODO: delete when new customize UI enabled for everyone
import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import ExitMessageStore from '../../stores/ExitMessageStore';
import SnackStore from '../../stores/SnackStore';
import FuseConfirmationModal from '../ConfirmationModal/FuseConfirmationModal';
import FuseConsoleCardFooter from '../ConsoleFragments/FuseConsoleCardFooter';
import FuseConsoleModal from '../ConsoleModal/FuseConsoleModal';
import { Card } from '../Fuse';
import FuseButton from '../FuseControls/FuseButton';
import FuseRadioButton from '../FuseControls/FuseRadioButton';
import FuseTextArea from '../FuseControls/FuseTextArea';
import PagePreview from '../PagePreview/PagePreview';
import { CardTitle, ExitMessageOptionField, ExitMessageOptionView, ExitMessageTextField } from './ExitMessageFields';
import ExitMessagePreview from './ExitMessagePreview';

class ConsoleExitMessageModal extends Component {
    static propTypes = {
        snack: SnackStore.PropType.isRequired,
        exitMessage: ExitMessageStore.PropType.isRequired,
    };

    submit = () => {
        const { exitMessage, snack } = this.props;
        exitMessage.update()
            .then(() => snack.showSuccess(<span><b>Exit Message</b> has been saved</span>))
            .catch((e) => e && snack.showError(<span>Failed to save <b>Exit Message</b> options. {e.message}</span>));
    }

    render() {
        const store = this.props.exitMessage;

        return <FuseConsoleModal
            isOpen={store.editModal.isOpen}
            onClose={store.closeEditModal}
            title="Edit Exit Message"
            headerActions={<FuseButton
                style={{ minWidth: 100 }}
                color="green"
                primary
                disabled={!store.hasChanged() || !store.isValid()}
                loading={store.updateStatus.isLoading}
                onClick={this.submit}
            >Save</FuseButton>}
        >
            <Card title={CardTitle}>
                <ExitMessageOptionField tooltipProps={{ position: 'bottomRight' }}>
                    {['DEFAULT', 'CUSTOM'].map((value) => <FuseRadioButton
                        key={value}
                        store={store.option}
                        value={value}
                        label={ExitMessageOptionView[value]}
                    />)}
                </ExitMessageOptionField>
                {store.isCustomMessageEditable() ? <Fragment>
                    <ExitMessageTextField>
                        <FuseTextArea
                            store={store.text}
                            rows={3}
                        />
                    </ExitMessageTextField>
                    <FuseConsoleCardFooter text="Text will not be translated to other languages." />
                </Fragment> : null}
            </Card>
            <Card title="Preview">
                <PagePreview
                    pageComponent={ExitMessagePreview}
                    previewToggle={store.modalPreviewToggle}
                    headline="Exit Message"
                    pageProps={{ exitMessage: store.getValue() }}
                />
            </Card>

            <FuseConfirmationModal
                store={store.exitConfirmationModal}
                onConfirm={store.editModal.close}
            />
        </FuseConsoleModal>;
    }
}

export default inject('snack', 'exitMessage')(observer(ConsoleExitMessageModal));
